<template>
  <div class="pay-info">
    <!-- <page-header title="我的缴费" /> -->

    <!-- <p>测试数据：{{ payInfo }}</p> -->

    <div v-if="baseInfoState == 1">
      <div>
        <strong>我要缴费</strong>
        <el-divider></el-divider>
        <p class="text-center">
          <el-button :loading="isLaoding" type="primary" @click="goTay()"> {{ btntext }} </el-button>
        </p>
      </div>
      <br />
      <br />
      <div>
        <strong>缴费计划</strong>
        <el-divider></el-divider>
        <ming-table v-model="payInfo.payPlan" :fields="column.plan"></ming-table>
      </div>

      <br />
      <br />
      <div>
        <strong>到账记录</strong>
        <el-divider></el-divider>
        <ming-table v-model="payInfo.receiptReport" :fields="column.receipt"></ming-table>
      </div>
      <br />
      <br />
      <div>
        <strong>退费记录</strong>
        <el-divider></el-divider>
        <ming-table v-model="payInfo.refundReport" :fields="column.refund"></ming-table>
      </div>
      <br />
      <br />
      <div>
        <strong>开票情况</strong>
        <el-divider> </el-divider>
        <ming-table v-model="payInfo.invoiceReport" :fields="column.invoice">
          <template #kp_id="{ scope }">
            <a v-if="scope.url" :href="scope.url" target="_blank" rel="noopener noreferrer" style="color: var(--theme-color); text-decoration: underline">{{ scope.kp_id }}</a>
            <span v-else>{{ scope.kp_id }}</span>
          </template></ming-table
        >
      </div>
      <br />
    </div>
    <div v-else>
      <p style="margin: 100px 0; text-align: center; color: #666; font-size: 14px">
        身份证号缺失，获取用户信息失败。请先到个人信息完善身份证号。 <el-button type="text" @click="goCenter">去填写</el-button>
      </p>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import API from '@/api'
import { Message, MessageBox } from 'element-ui'
// import PageHeader from '@/components/PageHeader'
const payInfo = reactive({ url: '', invoiceReport: null, receiptReport: null, payPlan: null, refundReport: null })
const baseInfoState = ref(1)
const isLaoding = ref(false)
const btntext = ref('我要缴费')
import Router from '@/router'
const goCenter = () => {
  Router.push({ name: 'UserCenter' })
}

const column = {
  plan: [
    {
      label: '缴费类型',
      field: 'typeName'
    },
    {
      label: '截止日期',
      field: 'date'
    },
    {
      label: '应缴金额（单位：元）',
      field: 'amount'
    },
    {
      label: '实缴金额（单位：元）',
      field: 'pamount'
    },
    {
      label: '未缴费金额（单位：元）',
      field: 'uamount'
    }
  ],
  receipt: [
    {
      label: '缴费类型',
      field: 'type'
    },
    {
      label: '到账金额（单位：元）',
      field: 'amount'
    },
    {
      label: '到账日期',
      field: 'date'
    },
    {
      label: '缴费方式',
      field: 'mode'
    }
  ],
  refund: [
    {
      label: '缴费类型',
      field: 'type'
    },
    {
      label: '到账金额（单位：元）',
      field: 'amount'
    },
    {
      label: '到账日期',
      field: 'date'
    }
  ],
  invoice: [
    {
      label: '开票ID',
      field: 'kp_id',
      slot: true
    },
    {
      label: '票据类型',
      field: 'billtype'
    },
    {
      label: '票据金额',
      field: 'amount'
    },
    {
      label: '收费类型',
      field: 'type'
    },
    {
      label: '票据抬头',
      field: 'title'
    },
    {
      label: '统一信用代码',
      field: 'unifiedcode'
    },
    {
      label: '开票日期',
      field: 'date'
    }
  ]
}
const goTay = () => {
  // baseInfoState.value = 1
  isLaoding.value = true
  API.payUrl()
    .then(res => {
      isLaoding.value = false
      if (res.code) {
        window.open(res.data.data)
        MessageBox.confirm('', '如已缴费请点击“确认”刷新缴费信息', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning',
          showClose: false,
          center: true,
          closeOnPressEscape: false,
          closeOnClickModal: false
        }).then(() => {
          getPayInfo()
        })
      } else {
        Message.error(res.msg)
      }
    })
    .catch(() => {
      isLaoding.value = false
      // Message.error(error.msg)
      return
    })
}

const getPayInfo = () => {
  API.payReport().then(res => {
    if (res.code) {
      payInfo.invoiceReport = res.data.invoice_detail
      payInfo.receiptReport = res.data.receipt_detail
      payInfo.refundReport = res.data.refund_detail
      if (!res.data.state) {
        baseInfoState.value += 1
      }
    } else {
      Message.error(res.msg)
    }
  })
  API.payPlan().then(res => {
    if (res.code) {
      payInfo.payPlan = res.data.plan_detail
      if (!res.data.state) {
        baseInfoState.value += 1
      }
    } else {
      Message.error(res.msg)
    }
  })
}
onMounted(() => {
  getPayInfo()
})
</script>

<style lang="scss" scoped>
.text-center {
  text-align: center;
}
</style>
